import { useState, useEffect, useRef } from 'react'

function useIsMobile(bp = 640) {
  const [m, setM] = useState(() => window.innerWidth < bp)
  useEffect(() => {
    let t; const h = () => { clearTimeout(t); t = setTimeout(() => setM(window.innerWidth < bp), 80) }
    window.addEventListener('resize', h); return () => { clearTimeout(t); window.removeEventListener('resize', h) }
  }, [bp]); return m
}

const BASE_URL = import.meta.env.VITE_API_URL || 'http://92.53.107.15'
const TG_BOT_USERNAME = 'ya_teper_bot'

const C = {
  bg:        '#05050d',
  surface:   'rgba(255,255,255,0.028)',
  border:    'rgba(180,185,230,0.09)',
  borderHi:  'rgba(180,185,230,0.2)',
  accent:    '#b8bdd4',
  accentDim: 'rgba(180,185,230,0.12)',
  text:      '#dce0f0',
  textMuted: '#8890aa',
  silverHi:  '#dce0f0',
  silverLo:  '#8890aa',
  green:     '#4dc88a',
}
const font = {
  heading: "'Cormorant Garamond', serif",
  mono:    "'Space Mono', monospace",
  body:    "'Inter', sans-serif",
}

function generateUUID() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}

function getVisitorId() {
  let id = localStorage.getItem('dt_visitor_id')
  if (!id) {
    id = generateUUID()
    localStorage.setItem('dt_visitor_id', id)
  }
  return id
}

function formatTime(iso) {
  return new Date(iso).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
}

export default function VisitorChat({ profileUserId = 'user' }) {
  const [messages, setMessages] = useState([])
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const visitorId = getVisitorId()
  const messagesRef = useRef(null)
  const inputRef = useRef(null)
  const isMobile = useIsMobile()

  useEffect(() => {
    const el = messagesRef.current
    if (el) el.scrollTop = el.scrollHeight
  }, [messages, loading])

  async function sendMessage(e) {
    e?.preventDefault()
    const text = input.trim()
    if (!text || loading) return
    setInput('')
    const userMsg = { role: 'user', message: text, created_at: new Date().toISOString() }
    setMessages(prev => [...prev, userMsg])
    setLoading(true)
    inputRef.current?.focus()
    try {
      const res = await fetch(`${BASE_URL}/api/bot/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ visitor_id: visitorId, message: text, profile_user_id: profileUserId }),
      })
      const data = await res.json()
      if (data.reply) {
        setMessages(prev => [...prev, {
          role: 'assistant',
          message: data.reply,
          created_at: new Date().toISOString(),
        }])
      } else if (data.error) {
        setMessages(prev => [...prev, {
          role: 'assistant',
          message: `Ошибка: ${data.error}`,
          created_at: new Date().toISOString(),
        }])
      }
    } catch {
      setMessages(prev => [...prev, {
        role: 'assistant',
        message: 'Не удалось отправить сообщение. Попробуйте позже.',
        created_at: new Date().toISOString(),
      }])
    } finally {
      setLoading(false)
      inputRef.current?.focus()
    }
  }

  function handleKey(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      sendMessage()
    }
  }

  return (
    <div style={{ marginBottom: 32 }}>
      {/* Disclaimer */}
      <div style={{
        background: C.accentDim,
        border: `1px solid ${C.border}`,
        borderRadius: 10, padding: '12px 16px', marginBottom: 16,
        fontFamily: font.body, fontSize: 13, color: C.textMuted, lineHeight: 1.7,
      }}>
        <strong style={{ color: C.accent }}>⚠ Вы общаетесь с цифровым двойником</strong> — ИИ, обученным на
        реальных текстах и данных личности. Это не живой человек, а его модель.{' '}
        <a
          href={`https://t.me/${TG_BOT_USERNAME}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: C.accent, textDecoration: 'underline' }}
        >
          Открыть в Telegram ↗
        </a>
      </div>

      {/* Chat window */}
      <div style={{
        background: C.surface, border: `1px solid ${C.border}`,
        borderRadius: 12, overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{
          padding: '12px 20px', borderBottom: `1px solid ${C.border}`,
          display: 'flex', alignItems: 'center', gap: 10,
        }}>
          <div style={{
            width: 32, height: 32, borderRadius: '50%',
            background: C.accentDim, border: `1px solid ${C.accent}`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: font.body, fontSize: 14, color: C.accent,
          }}>
            Д
          </div>
          <div>
            <div style={{ fontFamily: font.body, fontSize: 14, color: C.text, fontWeight: 500 }}>
              Цифровой двойник
            </div>
            <div style={{ fontFamily: font.body, fontSize: 11, color: C.green }}>
              ● онлайн
            </div>
          </div>
        </div>

        {/* Messages */}
        <div ref={messagesRef} style={{
          height: isMobile ? 320 : 400, overflowY: 'auto', padding: '16px 14px',
          display: 'flex', flexDirection: 'column', gap: 10,
        }}>
          {messages.length === 0 && (
            <div style={{
              textAlign: 'center', color: C.textMuted,
              fontFamily: font.body, fontSize: 13, marginTop: 80,
              lineHeight: 1.7,
            }}>
              Напишите что-нибудь, чтобы начать общение с двойником
            </div>
          )}

          {messages.map((m, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start',
              }}
            >
              <div style={{
                maxWidth: '75%', padding: '8px 14px', borderRadius: 12,
                background: m.role === 'user' ? C.accentDim : C.bg,
                border: `1px solid ${m.role === 'user' ? C.borderHi : C.border}`,
                fontFamily: font.body, fontSize: 13, color: C.text, lineHeight: 1.6,
              }}>
                {m.message}
                <div style={{ fontSize: 10, color: C.textMuted, marginTop: 4, textAlign: 'right' }}>
                  {formatTime(m.created_at)}
                </div>
              </div>
            </div>
          ))}

          {loading && (
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <div style={{
                padding: '8px 16px', borderRadius: 12,
                background: C.bg, border: `1px solid ${C.border}`,
                color: C.textMuted, fontFamily: font.body, fontSize: 18, letterSpacing: 2,
              }}>
                · · ·
              </div>
            </div>
          )}

        </div>

        {/* Input */}
        <form
          onSubmit={sendMessage}
          style={{
            display: 'flex', gap: 8, padding: '12px 20px',
            borderTop: `1px solid ${C.border}`,
          }}
        >
          <input
            ref={inputRef}
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={handleKey}
            placeholder="Введите сообщение... (Enter — отправить)"
            style={{
              flex: 1, background: C.bg, border: `1px solid ${C.border}`,
              borderRadius: 8, padding: '9px 14px', color: C.text,
              fontFamily: font.body, fontSize: 13, outline: 'none',
            }}
          />
          <button
            type="submit"
            disabled={loading || !input.trim()}
            style={{
              padding: '9px 20px', borderRadius: 8,
              cursor: loading || !input.trim() ? 'default' : 'pointer',
              fontFamily: font.body, fontSize: 13,
              background: C.accentDim, border: `1px solid ${C.accent}`,
              color: C.accent,
              opacity: loading || !input.trim() ? 0.4 : 1,
              transition: 'opacity 0.15s',
            }}
          >
            ↑
          </button>
        </form>
      </div>
    </div>
  )
}
